import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

function Opacity() {
  const { canvas, selectedObject, coreHandler } = useContext(AppContext);
  const [opacity, setOpacity] = useState(selectedObject?.opacity);

  // triggered by clicking layers
  useEffect(() => {
    setOpacity(selectedObject?.opacity);
  }, [selectedObject]);

  // triggered by fabric controls
  useEffect(() => {
    function onModified(event: any) {
      setOpacity(selectedObject?.opacity);
    }

    coreHandler?.eventHandler.on("object:modified", onModified);
    return () => {
      coreHandler?.eventHandler.off("object:modified", onModified);
    };
  }, [coreHandler, selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = Math.max(0, Math.min(parseFloat(event.target.value), 1));
    setOpacity(value);
    selectedObject?.set({ opacity: value });
    canvas?.renderAll();
  }

  return (
    <input
      type="number"
      onChange={onChange}
      value={opacity}
      min={0}
      max={1}
      step={0.1}
      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      placeholder="0.0-1.0"
    />
  );
}

export default Opacity;
